import React from 'react';
import ReactModal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faXmark } from '@fortawesome/free-solid-svg-icons';

import 'assets/styles/modal.css';

if (typeof document !== 'undefined') ReactModal.setAppElement('#root');

function getModalHeader(children) {
  return React.Children.toArray(children).find((child) => child && child.type === ModalHeader);
}

export function Modal({ active, size = 'sm', children }) {
  const header = getModalHeader(children);
  const closeModal = header && header.props.toggler ? header.props.toggler : () => {};

  return (
    <ReactModal
      isOpen={Boolean(active)}
      onRequestClose={closeModal}
      overlayClassName="ae-shared-modal-overlay"
      className={`ae-shared-modal ae-shared-modal--${size}`}
      bodyOpenClassName="ae-shared-modal-open"
      contentLabel="Fenêtre de dialogue"
      shouldCloseOnOverlayClick
    >
      <div className="ae-shared-modal-ring ae-shared-modal-ring--violet" aria-hidden="true" />
      {children}
    </ReactModal>
  );
}

export function ModalHeader({ children, toggler }) {
  return (
    <header className="ae-shared-modal-header">
      <h2>{children}</h2>
      <button type="button" className="ae-shared-modal-close" onClick={toggler} aria-label="Fermer">
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </header>
  );
}

export function ModalBody({ children }) {
  return <div className="ae-shared-modal-body">{children}</div>;
}

export function ModalFooter({ children }) {
  return (
    <footer className="ae-shared-modal-footer">
      <div className="ae-shared-modal-ring ae-shared-modal-ring--green" aria-hidden="true" />
      <div className="ae-shared-modal-actions">{children}</div>
    </footer>
  );
}

export function Button({ children, buttonType, color, className = '', type = 'button', ...props }) {
  const variant = buttonType === 'link'
    ? 'cancel'
    : buttonType === 'outline' || color === 'blue'
      ? 'secondary'
      : 'primary';
  const forwardedProps = { ...props };
  delete forwardedProps.ripple;

  return (
    <button
      type={type}
      className={`ae-shared-modal-button ae-shared-modal-button--${variant} ${className}`.trim()}
      {...forwardedProps}
    >
      <span className="ae-shared-modal-button-label">{children}</span>
      {variant === 'primary' && <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />}
    </button>
  );
}
